import { z } from 'zod'

import type { IconKey } from '@scalar-org/guide-icons'
import { slugify } from '@scalar-org/helpers/url'

/**
 * Internal JSON pointed to the value. Recommended to keep shared options objects in the `components` field of the configuration file.
 */
export const jsonRef = z.object({
  $ref: z
    .string()
    .describe(
      'Internal JSON pointed to the value. Recommended to keep shared options objects in the `components` field of the configuration file.',
    ),
})

export type Icon = IconKey | string

// Icon schema that accepts predefined icons, URLs, or local file paths
export const iconSchema = z.union([
  z
    .string()
    .meta({ schemaRef: 'https://cdn.scalar.com/schema/icon-enum.json' })
    .describe(
      "Predefined icon from the Scalar icon library (e.g., 'line/arrow-chevron-down', 'solid/interface-add', 'brand/programming-language-typescript')",
    ),
  z
    .string()
    .url()
    .describe(
      "URL to a remote icon file (e.g., 'https://example.com/icon.svg')",
    ),
  z
    .string()
    .describe(
      "Local file path relative to the project root (e.g., './assets/custom-icon.svg', '/images/logo.png')",
    ),
]) satisfies z.ZodType<Icon>

export const titleSchema = z
  .string()
  .describe('Title to show use in any navigation links')

/**
 * Get the path prefix for a nav version
 *
 * If the version is 'default', an empty prefix is set
 */
export function getVersionPathPrefix(version: string) {
  return version === 'default' ? '' : slugify(version)
}

/** Standard url path schema */
export const pathSchema = z.string().startsWith('/')
